import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/Steve-bio.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Steve Rudolph" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Steve Rudolph</h1>
        <div>
          <img
            src={Image}
            title="Steve bio"
            width={170}
            height={245}
            className="alignleft size-full wp-image-286"
            style={{ float: 'left' }}
          />
          <p />
          <p>
            <strong>Professional Focus:</strong> Leadership and management
            development; developing and coaching high performing teams;
            strategic thinking and execution; change management; executive
            coaching.
          </p>
          <p>
            For over twenty years, Steve has been helping organizations, teams,
            and leaders achieve higher levels of business and personal
            performance. His expertise is helping leaders identify clear and
            compelling goals and a measured path for achieving them. Steve links
            current training and development, performance coaching, and
            neuroscience research with the pragmatism of delivering measurable
            and sustained business results.
          </p>
          <p>
            Steve’s entrepreneurial acumen was forged in the heat of restaurant
            ownership and management. His purposeful <em>sense of urgency</em>{' '}
            for achieving results is the result of sleepless nights as a
            business owner. His guiding mantra with clients is{' '}
            <em>if you’re not getting better, you’re getting behind.</em>
          </p>
          <p>
            Steve is currently a senior coach and trainer with Next Level
            Performance and Gomez &amp;
            <br />
            Associates, organizational development and consulting firms located
            in Colorado Springs, Colorado. Steve’s current clients include FMC
            Technologies, Novo Nordisk Pharmaceuticals, Abbott Labs, U.S.
            Department of Education, to name a few.
          </p>
          <p>
            Steve is currently pursuing his executive coaching credentials with
            the International Coaching Federation. He is a recent graduate of
            Neuroleadership Group, a brain – based and leading neuroscience
            coaching organization founded by David Rock (author of Quiet
            Leadership and Your Brain at Work).
          </p>
          <p>
            Steve was an outdoor leadership faculty member at Prescott College
            in Prescott, Arizona. He was a senior instructor for the Pacific
            Crest Outward Bound School leading corporate development programs
            for such clients as AT&amp;T. Steve is a former coach and guide for
            the United States Disabled Ski Team, guiding two national champions
            in the World Games for the Disabled.
          </p>
          <p>
            During the summer Steve can be found sailing with his kids on Lake
            Michigan. During the other nine months he is either skiing or
            waiting for snow. He has resisted deer hunting so far, but has some
            great Sven and Ole jokes.
          </p>
          <p>
            <strong>Education</strong>
          </p>
          <ul style={{ width: '765px' }}>
            <li>
              <p>
                Steve has a Bachelor’s degree in Secondary Education for
                Prescott College and his Masters in Human and Organizational
                Development from the Fielding Institute in Santa Barbara,
                California.
              </p>
            </li>
          </ul>
          <p>
            Website:{' '}
            <a href="http://www.steverudolphcoaching.com/" target="_blank">
              SteveRudolphCoaching.com
            </a>{' '}
            | Phone: <span>231.330.8578</span> | Email:{' '}
            <a
              href="mailto:steve@gomezandassociates.com"
              alt="Email Steve Rudolph"
            >
              steve@gomezandassociates.com
            </a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
